import { render, staticRenderFns } from "./EdenFilterItems.vue?vue&type=template&id=e024975a&scoped=true"
import script from "./EdenFilterItems.vue?vue&type=script&lang=js"
export * from "./EdenFilterItems.vue?vue&type=script&lang=js"
import style0 from "./EdenFilterItems.vue?vue&type=style&index=0&id=e024975a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e024975a",
  null
  
)

export default component.exports